export default "__VITE_ASSET__CXO7sRmC__"